export const menuItems = [
  {
    label: "Pesquisa de Passagens",
    action: (setIsMenuOpen?: (state: boolean) => void) => {
      if (setIsMenuOpen) setIsMenuOpen(false);
      window.location.assign("/");
    },
  },
  {
    label: "Passagens Aéreas Baratas",
    action: (setIsMenuOpen?: (state: boolean) => void) => {
      if (setIsMenuOpen) setIsMenuOpen(false);
      window.location.href =
        "https://voopter.com.br/passagens-aereas-promocionais";
    },
  },
  {
    label: "Alertas",
    action: (setIsMenuOpen?: (state: boolean) => void) => {
      if (setIsMenuOpen) setIsMenuOpen(false);
      window.location.assign("/alertas");
    },
  },
  {
    label: "Achados",
    action: (setIsMenuOpen?: (state: boolean) => void) => {
      if (setIsMenuOpen) setIsMenuOpen(false);
      window.open(
        "https://achados.voopter.com.br/?utm_source=voopter-site",
        "_blank",
      );
    },
  },
  // {
  //   label: "Hotéis",
  //   action: (setIsMenuOpen?: (state: boolean) => void) => {
  //     if (setIsMenuOpen) setIsMenuOpen(false);
  //     window.open("https://skyscanner.pxf.io/ba6L1k", "_blank");
  //   },
  // },
];
